/**
 * Sidebar / route permission codenames — mirrors backend ``sidebar_permission_codenames``.
 * Resolved to numeric IDs via the permission map loaded at login.
 */

/** Sidebar item key → read permission codename (empty = always visible). */
export const SIDEBAR_PERMISSION_CODENAMES: Record<string, string> = {
  dashboard: '',
  inbox: 'view_inbox',
  customers: 'view_customers',
  segments: 'view_customersegment',
  templates: 'view_templates',
  campaigns: 'view_campaigns',
  flows: 'view_flows',
  wa_flows: 'view_whatsapp_flows',
  media_library: 'view_media_library',
  pipeline: 'view_pipeline',
  chatbot: 'view_chatbot',
  knowledge_base: 'view_knowledge_base',
  analytics: 'view_analytics',
  import_export: 'import_customers',
  ecommerce: 'view_ecommerce',
  csat: 'view_csat',
  integrations: 'view_integrations',
  billing: 'view_billing',
  documents: 'view_documents',
  settings: '',
}

/** Route path → permission codename(s). Any match grants access. */
export const ROUTE_PERMISSION_CODENAMES: Record<string, string | string[]> = {
  '/dashboard': '',
  '/inbox': 'view_inbox',
  '/customers': 'view_customers',
  '/segments': 'view_customersegment',
  '/templates': 'view_templates',
  '/campaigns': 'view_campaigns',
  '/flows': 'view_flows',
  '/wa-flows': 'view_whatsapp_flows',
  '/setu-media': 'view_media_library',
  '/analytics': 'view_analytics',
  '/knowledge-base': 'view_knowledge_base',
  '/ai-chatbot': 'view_chatbot',
  '/pipeline': 'view_pipeline',
  '/import-export': ['import_customers', 'export_customers'],
  '/ecommerce': 'view_ecommerce',
  '/catalog': 'view_templates',
  '/csat': 'view_csat',
  '/integrations': 'view_integrations',
  '/activity-log': 'view_apiactivitylog',
  '/billing': 'view_billing',
  '/settings': '',
  '/documents': 'view_documents',
  // Legacy path — redirects to /documents, gated the same way.
  '/help': 'view_documents',
  '/notifications': '',
}

export function codenamesForPath(path: string): string[] {
  const normalized = path.split('?')[0].replace(/\/$/, '') || '/'
  const base = '/' + normalized.split('/').filter(Boolean).slice(0, 1).join('/')
  const exact = ROUTE_PERMISSION_CODENAMES[normalized]
  if (exact !== undefined) {
    if (!exact || exact === '') return []
    return Array.isArray(exact) ? exact : [exact]
  }
  const prefix = ROUTE_PERMISSION_CODENAMES[base]
  if (prefix !== undefined) {
    if (!prefix || prefix === '') return []
    return Array.isArray(prefix) ? prefix : [prefix]
  }
  return []
}

export function codenamesForSidebarKey(key: string): string[] {
  const code = SIDEBAR_PERMISSION_CODENAMES[key]
  if (code === undefined || code === '') return []
  if (key === 'import_export') return ['import_customers', 'export_customers']
  return [code]
}
